<template>
  <asc-page-loading-indicator
    :loading="isDataLoading && apiPageFailure.length === 0"
  >
    <asc-container class="asc-feature-flags-container">
      <asc-feature-flags-template></asc-feature-flags-template>
    </asc-container>
  </asc-page-loading-indicator>
</template>

<script>
import AscContainer from '@/components/atoms/AscContainer'
import AscPageLoadingIndicator from '@/components/molecules/AscPageLoadingIndicator'
import { AscFeatureFlagsTemplate } from '@/components/templates'

export default {
  name: 'AscFeatureFlagsContainer',

  components: {
    AscContainer,
    AscPageLoadingIndicator,
    AscFeatureFlagsTemplate,
  },

  data() {
    return {
      isDataLoading: false,
    }
  },
}
</script>
